<template>
  <v-sheet height="72" class="text-center d-flex" style="border-top: 1px solid #ddd; width: 100vw; z-index: 50">
    <v-sheet width="20%" style="cursor: pointer;padding-top:6px" @click="$router.replace('/').catch(()=>{})">
      <img height="54" :src="$route.path == '/' ? require('@/assets/menus/main-active.png') : require('@/assets/menus/main.png')"></img>      
    </v-sheet>

    <v-sheet width="20%" style="cursor: pointer;padding-top:6px" @click="$router.push('/reservation/buy').catch(()=>{})">
      <img height="54" :src="$route.path.startsWith('/reservation') ? require('@/assets/menus/reservation-active.png') : require('@/assets/menus/reservation.png')"></img>
      <!-- <v-icon size="28" :style="$route.path.startsWith('/reservation') ? 'color:#ef7fab;' : ''"> mdi-ticket-confirmation-outline </v-icon>
      <p class="mb-0 text-caption" style="margin-top: -2px" :style="$route.path.startsWith('/reservation') ? 'color:#ef7fab;' : ''">예약하기</p> -->
    </v-sheet>   

    <v-sheet width="20%" style="cursor: pointer;padding-top:6px" @click="$router.push('/castle').catch(()=>{})">
      <img height="54" :src="$route.path.startsWith('/castle') ? require('@/assets/menus/guest-active.png') : require('@/assets/menus/guest.png')"></img>
    </v-sheet>
    
    <v-sheet width="20%" style="cursor: pointer;padding-top:6px" @click="$router.push('/makeup').catch(()=>{})">
      <img height="54" :src="$route.path.startsWith('/makeup') ? require('@/assets/menus/makeup-active.png') : require('@/assets/menus/makeup.png')"></img>
    </v-sheet>    

    <v-sheet width="20%" style="cursor: pointer;padding-top:6px" @click="goHome()">
      <img height="54" :src="$route.path.startsWith('/mypage') ? require('@/assets/menus/mypage-active.png') : require('@/assets/menus/mypage.png')"></img>      
    </v-sheet>
  </v-sheet>
</template>
<script>
export default {
  data: () => ({
    bottoms: [],
  }),

  methods: {
    goHome() {
      if(this.$store.state.lafia_user.is_logined) {
        this.$router.push("/mypage/home")
      } else {
        alert("로그인이 필요한 메뉴입니다.")
        this.$router.push("/auth/login")
      }
    }
  }
}
</script>
